import { Col, HelpBlock, Row } from 'react-bootstrap';
import { Field } from 'redux-form';
import FieldFormControl from '../../../../../../../components/FieldFormControl';
import { isRequired } from '../../../../../../../util/validators';
import * as React from 'react';
import { FormattedNumber } from 'react-intl';
import { FaSpinner } from 'react-icons/fa';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { actions as modalActions } from '../../../../../../../services/modal/reducer';
import { IModalActions, IModalState } from '../../../../../../../services/modal/model';

interface IOptionWithPopupProps {
  title: string,
  name: string,
  onOptionClick: any,
  currency: any,
  boltOnTotal: any,
  discountedPrice?: any,
  visibilityOfAddButton: boolean,
  selectedYesText?: any,
  selectedNoText?: any,
  visibilityName: string,
  unselectAdd: any,
  disabledCase: boolean,
  active: string | boolean,
  optionKeyName?: string,
  validationMessage?: string,
  modal: IModalState,
  props: any,
  actions: {
    modal: IModalActions
  }
}

const OptionWithPopup = (
  {
    title,
    name,
    onOptionClick,
    currency,
    boltOnTotal,
    discountedPrice,
    visibilityOfAddButton,
    selectedYesText,
    selectedNoText,
    visibilityName,
    unselectAdd,
    disabledCase = null,
    validationMessage = 'both',
    props = null,
    optionKeyName = null,
    actions,
    active,
  }: IOptionWithPopupProps) => {

  const error = get(props, `synchronousError.visibility.options.${optionKeyName}`, null);
  let hasIcon = false;
  let source = '';
  let subText;

  const openOptionsTextModal = () => {
    actions.modal.openOptionsModal(optionKeyName)
  }

  switch (optionKeyName) {
    case 'winter_sports':
      hasIcon = true;
      source = require('../../../img/ski.svg');
      subText = (
        <div className={'option-subtext'}>
          <div>
            The below cover is required if you plan on taking part in winter sports activities. If you do not select
            this cover you will have no cover for your trip, including any medical and trip cancellation costs.
          </div>
          <div style={{ marginTop: '20px' }}>
            Do you plan on taking part in winter sports activities?
          </div>
          <div>
            Check out our winter sports activities list <span
            style={{ textDecoration: 'underline', cursor: 'pointer', paddingBottom: '10px' }}
            onClick={openOptionsTextModal}>here</span>
          </div>
        </div>
      )
      break;
    case 'cruise_cover':
      hasIcon = true;
      source = require('../../../img/boat.svg');
      subText = (
        <div className={'option-subtext'}>
          <div>
            The below cover is required if you plan on taking a cruise. If you do not select this cover you will have no
            cover for your trip, including any medical and trip cancellation costs.
          </div>
          <div style={{ marginTop: '20px' }}>
            Do your travel plans include going on a cruise?
          </div>
          <div>
            Click <span
            style={{ textDecoration: 'underline', cursor: 'pointer', paddingBottom: '10px' }}
            onClick={openOptionsTextModal}>here</span> to see what we define as a cruise.
          </div>
        </div>
      )
      break;
    case 'excess_waiver':
      hasIcon = true;
      source = require('../../../img/no-money.svg');
      subText = (
        <div className={'option-subtext'}>
          <div>
            On the tier you have chosen, your excess in the event of a claim is £100 per person, per section, per claim.
            With our optional excess waiver cover, you wouldn’t have to pay an excess in the event of a claim.
          </div>
          <div>
            Do you want to remove your excess?
          </div>
        </div>
      )
      break;
    case 'gadget_cover':
      hasIcon = true;
      source = require('../../../img/headphone-symbol.svg');
      subText = (
        <div className={'option-subtext'}>
          <div>
            Do you need cover for any gadgets such as mobile phones, laptops, tablets and cameras that are lost, stolen
            or damaged during your trip?
          </div>
        </div>
      )

      break;
    case 'enhanced_trip_disruption':
      hasIcon = true;
      source = require('../../../img/enhanced-trip-disruption.svg');
      subText = (
        <div className={'option-subtext'}>
          <p>
            Do you need cover for delays of 6 hours or more caused by technical faults, mid-air emergencies,
            airspace closures or air traffic control restrictions, or cover for pre-booked connecting transport
            (e.g. stopovers) to reach your trip destination or return home if it is missed or delayed?
          </p>
          <p>
            As standard the policy includes cover for delays of 12 hours or more caused by mechanical breakdowns,
            industrial action, strikes, or severe weather conditions. You will also be covered if you abandon your
            trip if it is cancelled or delayed by 12 hours or more without alternative transport in that time.
            The policy does not cover missed international departures or delays to any connecting flights or other
            transport that does not leave from or enter the UK.
          </p>
        </div>
      )

      break;
  }

  const showSubText = () => {
    if (active && selectedYesText) {
      return (
        <div className={'yes-text'}>
          <div className={'yes-text-container'}>
            <div className={'yes-text-content'}>{selectedYesText}</div>
            <div className={'yes-text-add-button'}>{renderAddButton()}</div>
          </div>
        </div>
      );
    }
    if (active === false && selectedNoText && optionKeyName !== 'gadget_cover') {
      return (
        <div
          className={'no-text'}>{selectedNoText}
        </div>);
    }
  };

  const renderPrice = () => {
    return (
      <>
        <span style={{ textDecoration: discountedPrice !== null ? 'line-through' : '' }}>
          <FormattedNumber
            value={boltOnTotal}
            style="currency"
            currency={currency}
          />
        </span>

        {discountedPrice !== null &&
          <FormattedNumber
            value={discountedPrice}
            style="currency"
            currency={currency}
          />
        }
      </>
    )
  }

  const renderButtons = () => {
    return (
      <div className={'option-yes-no-buttons-container'}>
        <div className={'yes-no-button-c'}>
          <div className="radio-button-yes" style={{ paddingRight: '20px' }}>
            <div style={{ width: '120px', textAlign: 'right' }}>
              <Field
                name={visibilityName ? `visibility.${visibilityName}` : `visibility.${name}`}
                type="radio"
                format={null}
                value={true}
                complexValue={true}
                className="answer"
                validationMessage={validationMessage}
                component={FieldFormControl}
                validate={[isRequired]}
                disabled={disabledCase}
              >
                <div className="option-btn yes">
                  Yes
                </div>
              </Field>
            </div>
          </div>
          <div className="radio-button-no">
            <div style={{ width: '120px', textAlign: 'right' }}>
              <Field
                name={visibilityName ? `visibility.${visibilityName}` : `visibility.${name}`}
                type="radio"
                format={null}
                value={false}
                complexValue={true}
                className="answer"
                validationMessage={validationMessage}
                component={FieldFormControl}
                validate={[isRequired]}
                onClick={unselectAdd}
                disabled={disabledCase}
              >
                <div className="option-btn no">
                  No
                </div>
              </Field>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const renderAddButton = () => {
    return (
      <>
        {visibilityOfAddButton &&
          <div className="option-question-container options-section">
            <div className="mta-option-question" style={{ textAlign: 'right' }}>
              <Field
                name={name}
                type="checkbox"
                value={true}
                complexValue={false}
                className="answer"
                component={FieldFormControl}
                onClick={onOptionClick}
                validate={[isRequired]}
                disabled={disabledCase}
              >
                <div className="mta-option-btn">
                  <div className="option-content">
                    <span className="add">ADD  </span>
                    <span className="remove">REMOVE</span>
                    {boltOnTotal ? (
                      renderPrice()
                    ) : (
                      <FaSpinner className="fa-spin"/>
                    )}
                  </div>
                </div>
              </Field>
            </div>
          </div>}
      </>
    )
  }

  return (
    <div className="medical-question option-section">
      <div className="mta-option-container">
        {hasIcon && (
          <div className="mta-option-body">
            <img src={source} alt="Admiral" className="additional-cover-icon-desktop-ws-cc"/>
            <div className={'mta-body-container'}>
              <div className={'mta-o-body-text'}>
                <div className="title">{title}</div>
                <div>{subText}</div>
              </div>
              {renderButtons()}
            </div>
          </div>
        )}
      </div>

      <div style={{ paddingLeft: '64px', marginTop: '15px', fontSize: '14px' }}>
        {active && selectedYesText && optionKeyName === 'gadget_cover' && (
          <div>{selectedNoText}</div>
        )}
      </div>

      {error && validationMessage !== 'both' && props.submitFailed && (
        <Row style={{ textAlign: 'center' }}>
          <Col>
            <div className={error ? 'has-error' : ''}>
              {<HelpBlock>{error}</HelpBlock>}
            </div>
          </Col>
        </Row>
      )}

      <div className={'option-subtext-display'}>
        <div>{showSubText()}</div>
      </div>
    </div>
  );

}

export default connect(
  (state: IStore) => {
    return {
      modal: state.modal,
    };
  },
  (dispatch) => ({
    actions: {
      modal: bindActionCreators({ ...modalActions }, dispatch),

    },
  }))(OptionWithPopup);
